
var KEYCODE = {
    DOWN: 40,
    LEFT: 37,
    RIGHT: 39,
    SPACE: 32,
    UP: 38
};

function firstRadioButton(node) {

    var first = node.parentNode.firstChild;

    while (first) {
        if (first.nodeType === Node.ELEMENT_NODE) {
            if (first.getAttribute("role") === 'radio') return first;
        }
        first = first.nextSibling;
    }

    return null;
}

function lastRadioButton(node) {

    var last = node.parentNode.lastChild;

    while (last) {
        if (last.nodeType === Node.ELEMENT_NODE) {
            if (last.getAttribute("role") === 'radio') return last;
        }
        last = last.previousSibling;
    }

    return last;
}

function nextRadioButton(node) {

    var next = node.nextSibling;

    while (next) {
        if (next.nodeType === Node.ELEMENT_NODE) {
            if (next.getAttribute("role") === 'radio') return next;
        }
        next = next.nextSibling;
    }

    return null;
}

function previousRadioButton(node) {

    var prev = node.previousSibling;

    while (prev) {
        if (prev.nodeType === Node.ELEMENT_NODE) {
            if (prev.getAttribute("role") === 'radio') return prev;
        }
        prev = prev.previousSibling;
    }

    return null;
}

function setRadioButton(node, state) {
    if (state == 'true') {
        node.setAttribute('aria-checked', 'true');
        node.tabIndex = 0;
        node.focus();
        //we need to click the label for the Bootstrap classes and logic to kick in
        $(node).trigger('click');
    }
    else {
        node.setAttribute('aria-checked', 'false');
        node.tabIndex = -1;
    }
}

export const clickRadioGroup = (event) => {
    var type = event.type;

    if (type === 'click') {
        // If either enter or space is pressed, execute the funtion

        var node = event.currentTarget;

        var radioButton = firstRadioButton(node);

        while (radioButton) {
            setRadioButton(radioButton, "false");
            radioButton = nextRadioButton(radioButton);
        }

        setRadioButton(node, "true");

        event.preventDefault();
        event.stopPropagation();
    }
};

export const keyDownRadioGroup = (event) => {
    var type = event.type;
    var next = false;

    if (type === "keydown") {
        var node = event.currentTarget;

        switch (event.keyCode || event.which) {
            case KEYCODE.DOWN:
            case KEYCODE.RIGHT:
                next = nextRadioButton(node);
                if (!next) next = firstRadioButton(node); //if node is the last node, node cycles to first.
                break;

            case KEYCODE.UP:
            case KEYCODE.LEFT:
                next = previousRadioButton(node);
                if (!next) next = lastRadioButton(node); //if node is the last node, node cycles to first.
                break;

            case KEYCODE.SPACE:
                next = node;
                break;
        }

        if (next) {
            var radioButton = firstRadioButton(node);

            while (radioButton) {
                setRadioButton(radioButton, "false");
                radioButton = nextRadioButton(radioButton);
            }

            setRadioButton(next, "true");

            event.preventDefault();
            event.stopPropagation();
        }
    }
};
